var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 -5 30 30",
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Send blue@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exportable-icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-75.000000, -40.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Send-blue",
    transform: "translate(75.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.967287,-3.60008319e-14 L19.5681128,21.8196784 C19.4000778,22.4987582 18.7133555,22.9130418 18.0342757,22.7450068 C17.8144,22.6905996 17.6131357,22.5782284 17.4514498,22.4195994 L10.5385935,15.6374433 C10.0392313,15.1475224 10.0315776,14.34555 10.5214985,13.8461877 C10.5305952,13.8369157 10.539834,13.8277841 10.5492116,13.8187963 L24.967287,-3.60008319e-14 L24.967287,-3.60008319e-14 Z",
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.967287,-2.0250468e-14 L7.81096679,11.4278463 C7.31990804,11.7549411 6.66804256,11.6996661 6.2390711,11.2945572 L1.74774673,7.05307368 C1.23913867,6.57275817 1.21620302,5.77107722 1.69651853,5.26246915 C1.87203945,5.07660933 2.09969014,4.94820787 2.34954692,4.89414258 L24.967287,-2.0250468e-14 L24.967287,-2.0250468e-14 Z",
    id: "Rectangle"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.255313ada040d30df24a9cf2f15ffa14.svg";
export { ForwardRef as ReactComponent };